export default "__VITE_ASSET__DLLcyFQ___"